import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { RawTask } from './RawTask.js';
export var TaskFactory = /*#__PURE__*/function () {
  function TaskFactory(onError) {
    _classCallCheck(this, TaskFactory);

    this.onError = onError;
    this.freeTasks = [];
  }

  _createClass(TaskFactory, [{
    key: "create",
    value: function create(task) {
      var tasks = this.freeTasks;
      var t1 = tasks.length ? tasks.pop() : new RawTask(this.onError, function (t) {
        return tasks[tasks.length] = t;
      });
      t1.task = task;
      return t1;
    }
  }]);

  return TaskFactory;
}();